export default class staff {
  firstName: string;
  lastName: string;
  emailId: string;
  contactNumber: string;

  constructor() {
    this.firstName = '';
    this.lastName = '';
    this.emailId = '';
    this.contactNumber = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/authentication/signup/signup.staff.model.ts